import { Icon } from '@iconify/react';
import React from 'react';

interface Project {
	title: string;
	desc: string;
	images: string[];
	repo_link?: string;
	demo_link?: string;
}
function Portfolio() {
	const projects: Project[] = [
		{
			title: "Fyyur",
			desc: "Fyyur is a musical venue and artist booking site that facilitates the discovery and bookings of shows between local performing artists and venues. This site lets you list new artists and venues, discover them, and list shows with artists as a venue owner.",
			repo_link: "https://github.com/Kimbohlovette/Fyyur",
			demo_link: "",
			images: [require("../assets/image-fyyur.png")],
		},
		{
			title: "Trivia",
			desc: "Trivia web application is a trivia game running on the web. Students and/or competitors are asked questions about interesting but unimportant subjects. Students can take questions from a certain category or from all category play the trivia game.",
			repo_link: "https://github.com/Kimbohlovette/Trivia",
			demo_link: "https://trivia-two-topaz.vercel.app",
			images: [require("../assets/image-trivia.png")],
		},
		// {
		// 	title: "Coffee Shop",
		// 	desc: "Coffe Shop is new digitally enabled coffee shop where students can order drinks, socialize, and study.",
		// 	repo_link: "https://github.com/Kimbohlovette/CoffeeShop",

		// 	images: [],
		// },
		{
			title: "WhoGet",
			desc: "A mobile application used to connect people who need common goods and services to those who have them. You post what you need and it is seen buy those who visit the platform. Whoget is built with React Native and the Admin dashboard is built with NextJs.",
			demo_link: "",
			repo_link: "https://github.com/Kimbohlovette/whoget-mobile-client",
			images: [require("../assets/image-whoget.png")],
		},
		{
			title: "Farmino",
			desc: "Building a efarm platform where farmers can list and showcase their items, buyers can see, buy and read more about the items and go forward to purchase the product.",
			repo_link: "https://github.com/Kimbohlovette/farmino",
			demo_link: "https://farmino.netlify.app/",
			images: [require("../assets/image-farmino.png")],
		},
		{
			title: "Iknite Calculator",
			desc: "A simple business calculator developed with javascript and css only.",
			repo_link:
				"https://github.com/Kimbohlovette/iknitespace-exercises/tree/main/iknite-ex5",
			demo_link: "https://iknite-calculator.netlify.app/",
			images: [require("../assets/image-calculator.png")],
		},
		{
			title: "Iknite Portfolio Manager",
			desc: "A react app for showcasing iknite space projects, events and members' portfolio. This project was strictly for practical purpose.",
			repo_link:
				"https://github.com/Kimbohlovette/iknite-portfolio-manager",
			demo_link: "https://iknite-portfolio-manager.netlify.app/members",
			images: [require("../assets/image-ikinte-portfolio.png")],
		},
	];
	return (
		<section className="px-4 sm:px-12 md:px-16 max-w-7xl mx-auto">
			<div className="grid grid-cols-[repeat(auto-fit,_minmax(auto,_1fr))] gap-5  sm:grid-cols-[repeat(auto-fit,_minmax(300px,_1fr))] lg:grid-cols-[repeat(auto-fit,_minmax(300px,_1fr))] justify-center">
				{projects.map((project, key) => (
					<ProjectCard {...project} key={key} />
				))}
			</div>
		</section>
	);
}

export default Portfolio;

export interface ProjectType {
	title: string;
	description: string;
	demoImages: string[];
	liveLink: string;
	githubLink: string;
	technologies: string[];
	complemented: boolean;
}

const ProjectCard = ({
	title,
	images,
	repo_link,
	demo_link,
	desc,
}: Project) => {
	// { project }: { project: ProjectType }
	return (
		<div className="group bg-white group border w-full rounded-md hover:-translate-y-2 transition-all duration-300 ease-linear  overflow-hidden">
			<div className="flex flex-col">
				<div className="flex-1 text-violet-500">
					<img
						src={
							images.length > 0
								? images[0]
								: require("../assets/projectImage.jpg")
						}
						alt=""
						className="hover:scale-105 transition-all delay-100 duration-500 ease-in"
					/>
				</div>
				<div className="flex-1  px-4 py-4">
					<header className="flex items-center justify-between flex-wrap">
						<h2 className="text-slate-700 font-semibold text-lg sm:text-xl my-5">
							{title}
						</h2>
						<div className="flex items-center gap-2">
							{repo_link && (
								<a
									href={repo_link}
									target="_blank"
									className="block hover:bg-gray-300 p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
									rel="noreferrer"
								>
									<Icon icon="mdi:github" fontSize={18} />
								</a>
							)}
							{demo_link && (
								<a
									href={demo_link}
									target="_blank"
									className="block hover:bg-gray-300 p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"
									rel="noreferrer"
								>
									<Icon
										icon={"mdi:insert-link"}
										fontSize={20}
									/>
								</a>
							)}
						</div>
					</header>
					<p className="line-clamp-3 text-slate-600">{desc}</p>
				</div>
			</div>
			<div className="relative py-4 mt-2">
				{/* <div className="absolute top-0 left-0 w-full invisible group-hover:visible flex justify-between">
					<a
						href={'https://github.com/kimbohlovette'}
						target="_blank"
						className="bg-blue-100 py-1.5 text-sm font-semibold px-2 rounded-lg  flex items-center gap-2"
					>
						Github <Icon icon="iconamoon:link-external-thin" />
					</a>

					<a
						href="https://github.com/kimbohlovette"
						target="_blank"
						className="bg-blue-100 py-1.5 text-sm font-semibold px-2 rounded-lg  flex items-center gap-2"
					>
						<span>Visit site</span>{' '}
						<Icon icon="iconamoon:link-external-thin" />
					</a>
				</div> */}
			</div>
		</div>
	);
};
